import { Injectable, OnDestroy } from '@angular/core';
import { ConfigInitializerService, getContextParameterDefault, SiteContextConfig } from '@spartacus/core';
import { Observable, Subscription } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { COUNTRY_CONTEXT_ID } from './context-ids';
import { CountryStatePersistenceService } from './country-state-persistence.service';
import { CountryService } from './country.service';

@Injectable()
export class CountryInitializer implements OnDestroy {
  protected subscription: Subscription;

  constructor(
    protected countryService: CountryService,
    protected countryStatePersistenceService: CountryStatePersistenceService,
    protected configInit: ConfigInitializerService
  ) {}

  /**
   * Initializes the value of the active country.
   */
  initialize(): void {
    this.subscription = this.configInit
      .getStable('context')
      .pipe(
        // TODO(#12351): <--- plug here explicitly SiteContextRoutesHandler
        switchMap(() => this.countryStatePersistenceService.initSync()),
        switchMap(() => this.setFallbackValue())
      )
      .subscribe();
  }

  /**
   * On subscription to the returned observable:
   *
   * Sets the default value taken from config, unless the active country has been already initialized.
   */
  protected setFallbackValue(): Observable<unknown> {
    return this.configInit
      .getStable('context')
      .pipe(tap((config: SiteContextConfig) => this.setDefaultFromConfig(config)));
  }

  /**
   * Sets the active country value based on the default value from the config,
   * unless the active country has been already initialized.
   */
  protected setDefaultFromConfig(config: SiteContextConfig): void {
    const contextParam = getContextParameterDefault(config, COUNTRY_CONTEXT_ID);
    if (!this.countryService.isInitialized() && contextParam) {
      this.countryService.setActive(contextParam);
    }
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
